export default __webpack_public_path__ + "static/media/stmichael.fd096464.jpg";